import React from "react";
import { Check, Tags } from "lucide-react";
import { NETWORKING_CATEGORIES, MAX_NETWORKING_CATEGORIES } from "../utils/categories";

/**
 * Selector de categorías de networking: una rejilla de etiquetas que se
 * encienden al pulsarlas, con un tope de selecciones.
 *
 * Se usa igual en el registro y en el perfil, así que el componente no sabe
 * nada de formularios: recibe el array elegido y devuelve el nuevo.
 */
export default function CategoryPicker({
  value = [],
  onChange,
  options = NETWORKING_CATEGORIES,
  max = MAX_NETWORKING_CATEGORIES,
  id = "category-picker",
}) {
  const atLimit = value.length >= max;

  const toggle = (category) => {
    if (value.includes(category)) {
      onChange(value.filter((item) => item !== category));
      return;
    }
    // Llegados al tope, las no elegidas dejan de responder: así se ve que hay
    // un límite sin que desaparezcan de la lista
    if (!atLimit) onChange([...value, category]);
  };

  return (
    <div className="dyd-cat-picker" id={id}>
      <div className="dyd-cat-head">
        <span className="dyd-hint">
          <Tags size={13} style={{ verticalAlign: "-2px", marginRight: 5 }} />
          Elige hasta {max}
        </span>
        <span className={`dyd-cat-count ${atLimit ? "is-full" : ""}`}>
          {value.length}/{max}
        </span>
      </div>

      <div className="dyd-cat-list" role="group" aria-labelledby={id}>
        {options.map((category) => {
          const selected = value.includes(category);
          return (
            <button
              key={category}
              type="button"
              className={`dyd-cat-option ${selected ? "is-selected" : ""}`}
              onClick={() => toggle(category)}
              aria-pressed={selected}
              disabled={!selected && atLimit}
            >
              {selected && <Check size={13} />}
              {category}
            </button>
          );
        })}
      </div>

      {atLimit && (
        <small className="dyd-hint">
          Has llegado al máximo. Quita una categoría para elegir otra.
        </small>
      )}
    </div>
  );
}
